<script lang="ts" setup>
import ProductForm from "@/data-views/forms/user_profile/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "User",
  },
});
</script>

<template>
  <div>
    <ProductForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
